import { CHART_TYPES } from '../../../components/Chart/constants/chartTypes';
import { RETENTION_CHART_MAX_MEASURE_COUNT } from '../../../components/Chart/constants/utils';
import {
  ChartNumberType,
  ChartSortEnum,
  IDisplayedMeasureSetting,
} from '../../../components/Chart/interfaces';
import { IChartSettings } from '../../../components/Chart/interfaces';
import { IRetentionAnalysis } from '../../../utils/apollo/responseTypes';
import { getRowHeaderKeys } from '../../../utils/builder';
import { assertNotNil } from '../../../utils/types';
import { generateDisplayedSliceSettings, initialChartSettings } from './utils';

const generateRetentionDisplayedMeasure = (
  analysis: IRetentionAnalysis,
): IDisplayedMeasureSetting[] => {
  const { data } = analysis;
  assertNotNil(data);

  const rowHeaderKeys = getRowHeaderKeys(data);
  return rowHeaderKeys
    .slice(0, RETENTION_CHART_MAX_MEASURE_COUNT)
    .map((key) => ({
      isVisible: true,
      format: null,
      key,
    }));
};

export const generateRetentionDefaultSettings = (
  analysis: IRetentionAnalysis,
): IChartSettings => {
  const displayedSliceSettings = generateDisplayedSliceSettings({
    analysis,
    visibleCount: 1,
  });
  const displayedMeasureSettings = generateRetentionDisplayedMeasure(analysis);

  return {
    ...initialChartSettings,
    chartType: CHART_TYPES.RETENTION,
    displayedSliceSettings,
    displayedMeasureSettings,
    isChurn: false,
    chartNumberType: ChartNumberType.Percentage,
    singleDayLabel: '',
    sort: ChartSortEnum.ASC,
  };
};
